import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";

const MouseBackground = () => {
  const [mouse, setMouse] = useState({
    x: typeof window !== "undefined" ? window.innerWidth / 2 : 0,
    y: typeof window !== "undefined" ? window.innerHeight / 2 : 0,
  });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMouse({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  return (
    <Box
      sx={{
        pointerEvents: "none",
        position: "fixed",
        inset: 0,
        zIndex: 0,
        background: `
          radial-gradient(
            500px circle at ${mouse.x}px ${mouse.y}px,
            rgba(0, 180, 255, 0.10),
            transparent 40%
          )
        `,
        transition: "background 0.15s ease-out",
      }}
    />
  );
};

export default MouseBackground;
